import { useState, useCallback } from 'react';

type UseCopyToClipboardResult = {
    copied: boolean;
    copying: boolean;
    copy: (text: string) => Promise<void>;
};

export const useCopyToClipboard = (resetDelay = 1500): UseCopyToClipboardResult => {
    const [copied, setCopied] = useState(false);
    const [copying, setCopying] = useState(false);

    const copy = useCallback(
        async (text: string) => {
            if (!text || copying) return;
            setCopying(true);
            try {
                await navigator.clipboard.writeText(text);
                setCopied(true);
                setTimeout(() => setCopied(false), resetDelay);
            } catch {
                // silent fail — caller decides on error UX
            } finally {
                setCopying(false);
            }
        },
        [copying, resetDelay],
    );

    return { copied, copying, copy };
};
